import { isEmpty } from 'lodash-es';
import { createContext, ReactElement, useContext, useEffect, useState } from 'react';
import { getMessageAndInteractionPipeline } from 'wisestep-api';
import { IMessageAndInteractionPipeline } from 'wisestep-base';

import DefaultStageState from '../../utils/DefaultStageState';

export const StatusActionPipelineContext = createContext<IMessageAndInteractionPipeline | null>(
  null
);

interface StatusActionPipelineContextProviderProps {
  children: ReactElement;
}

export default function StatusActionPipelineContextProvider({
  children,
}: StatusActionPipelineContextProviderProps) {
  const [pipeline, setPipeline] = useState<IMessageAndInteractionPipeline | null>(null);
  useEffect(() => {
    if (isEmpty(pipeline)) {
      (async function () {
        try {
          const req = await getMessageAndInteractionPipeline();
          if (
            !isEmpty(req.data.candidateInteractionMessagingPipeline) &&
            !isEmpty(req.data.candidateInteractionResultPipeline)
          ) {
            setPipeline(req?.data);
          } else {
            setPipeline(DefaultStageState);
          }
        } catch (e) {
          setPipeline(DefaultStageState);
        }
      })();
    }
  }, [pipeline]);
  return (
    <>
      {pipeline && (
        <StatusActionPipelineContext.Provider value={{ ...pipeline }}>
          {children}
        </StatusActionPipelineContext.Provider>
      )}
    </>
  );
}

export function useStatusActionPipelineContext() {
  const context = useContext(StatusActionPipelineContext);
  if (!context) {
    throw new Error('useAppState must be used within the StatusActionPipelineContextProvider');
  }
  return context;
}
